import { getStream } from '../base/selectors';
import { CursorStream } from './types';

function getCursorStream<TItems = any, TParams extends object = any>(
  state,
  streamId: string
): CursorStream<TItems, TParams> {
  return getStream<TItems, TParams>(state, streamId) as CursorStream<
    TItems,
    TParams
  >;
}

export const getCursor = (state, streamId: string) =>
  getCursorStream(state, streamId).cursor;

export const getPrevCursor = (state, streamId: string) =>
  getCursorStream(state, streamId).prevCursor;
